import fetchIntercept from "fetch-intercept";

export const requestInterceptor = (url: string, config: any, tenantId: string, apiKey?: string) => {
  if (url.indexOf("/") !== 0) {
    return [url, config]; // This is not relative link - reaches outside world
  }
  const apiKeyObject = apiKey ? { "sk-magic-api-key": apiKey } : {};
  const headers = {
    ...(config ? config.headers : {}),
    "tenant-id": tenantId,
    ...apiKeyObject
  };
  return [url, { ...config, headers }];
};

export function registerTenantInterceptor(tenantId: string, apiKey?: string) {
  try {
    console.info("Register tenant interceptor");
    return fetchIntercept.register({
      request(url, config) {
        return requestInterceptor(url, config, tenantId, apiKey);
      }
    });
  } catch (e) {
    console.error("Failed to register tenant interceptor", e);
    throw e;
  }
}
